import { tv, VariantProps } from "tailwind-variants";
import { cn } from "@repo/utils/cn";
import { twMergeConfig } from "@repo/utils/twMergeConfig";
import { Slot } from "radix-ui";
import * as React from "react";
import { ComponentProps } from "react";

export const box = tv(
  {
    base: "",
    variants: {
      variant: {
        full: "ui:col-span-full",
        major: "ui:col-span-full",
        half: "ui:col-span-full",
        minor: "ui:col-span-6",
        micro: "ui:col-span-6",
        majorGrow: "ui:col-span-full",
        minorGrow: "ui:col-span-6",
        microGrow: "ui:col-span-6",
      },
      mdVariant: {
        full: "ui:md:col-span-full",
        major: "ui:md:col-span-full",
        half: "ui:md:col-span-6",
        minor: "ui:md:col-span-6",
        micro: "ui:md:col-span-4",
        majorGrow: "ui:md:col-span-full",
        minorGrow: "ui:md:col-span-6",
        microGrow: "ui:md:col-span-8",
      },
      xlVariant: {
        full: "ui:xl:col-span-full",
        major: "ui:xl:col-span-8",
        half: "ui:xl:col-span-6",
        minor: "ui:xl:col-span-4",
        micro: "ui:xl:col-span-2",
        majorGrow: "ui:xl:col-span-4",
        minorGrow: "ui:xl:col-span-8",
        microGrow: "ui:xl:col-span-10",
      },
    },
    defaultVariants: {
      variant: "full",
    },
  },
  {
    twMergeConfig,
  },
);

export type BoxProps = VariantProps<typeof box> & {
  className?: string;
} & (
    | {
        asChild: true;
        children?: React.ReactNode;
      }
    | ({
        asChild?: false;
      } & ComponentProps<"div">)
  );

export function Box({
  asChild,
  className,
  variant,
  mdVariant,
  xlVariant,
  ...props
}: BoxProps) {
  const Component = asChild ? Slot.Root : "div";

  return (
    <Component
      className={cn(
        box({
          variant,
          mdVariant: mdVariant || variant,
          xlVariant: xlVariant || mdVariant || variant,
        }),
        className,
      )}
      {...props}
    />
  );
}
